import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import {
  getUnderwritingUiEmbedUrl,
  GetUnderwritingUiEmbedUrlRequest,
  GetUnderwritingUiEmbedUrlResponse,
} from "../../actions/underwriting-ui.action";
import dispatch from "../../middleware";

export default function useUnderwritingUiEmbedUrl(
  payload: GetUnderwritingUiEmbedUrlRequest | null,
  missingPayloadError: string
) {
  const storeDispatch = useDispatch();
  const [embedUrl, setEmbedUrl] = useState("");
  const [isLoading, setIsLoading] = useState(Boolean(payload));
  const [error, setError] = useState("");
  const payloadKey = useMemo(() => JSON.stringify(payload), [payload]);

  useEffect(() => {
    if (!payload) {
      setEmbedUrl("");
      setError(missingPayloadError);
      setIsLoading(false);
      return;
    }

    const activePayload = payload;
    let isCancelled = false;

    async function load() {
      try {
        setIsLoading(true);
        setError("");
        setEmbedUrl("");
        const response = (await dispatch(
          storeDispatch,
          getUnderwritingUiEmbedUrl(activePayload)
        )) as GetUnderwritingUiEmbedUrlResponse | undefined;
        if (!response?.url) {
          throw new Error("Failed to load underwriting view");
        }
        if (!isCancelled) setEmbedUrl(response.url);
      } catch (e: any) {
        if (!isCancelled) {
          setEmbedUrl("");
          setError(e.message || "Failed to load underwriting view");
        }
      } finally {
        if (!isCancelled) setIsLoading(false);
      }
    }

    load();

    return () => {
      isCancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payloadKey, missingPayloadError, storeDispatch]);

  return { embedUrl, isLoading, error };
}
